// src/api/publicaciones.js
import api from "./config.js";

// Obtener todas las publicaciones
export const getPublicaciones = async () => {
    const { data } = await api.get("/publicaciones");
    return Array.isArray(data) ? data : data.publicaciones || [];
};

// Obtener una publicación por ID
export const getPublicacion = async (id) => {
    const { data } = await api.get(`/publicaciones/${id}`);
    return data;
};

// Crear una nueva publicación
export const createPublicacion = async (publicacionData) => {
    const formData = new FormData();
    
    // Agregar todos los campos al FormData
    Object.keys(publicacionData).forEach(key => {
        if (publicacionData[key] !== null && publicacionData[key] !== undefined) {
            formData.append(key, publicacionData[key]);
        }
    });
    
    const { data } = await api.post("/publicaciones", formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return data;
};

// Actualizar publicación
export const updatePublicacion = async (id, publicacionData) => {
    const formData = new FormData();
    
    // Agregar todos los campos al FormData
    Object.keys(publicacionData).forEach(key => {
        if (publicacionData[key] !== null && publicacionData[key] !== undefined) {
            formData.append(key, publicacionData[key]);
        }
    });
    
    const { data } = await api.put(`/publicaciones/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return data;
};

// Eliminar publicación
export const deletePublicacion = async (id) => {
    const { data } = await api.delete(`/publicaciones/${id}`);
    return data;
};
